import { Skeleton } from "@/components/ui/skeleton"

/**
 * OKS-468 — Loading fallback for the deferred first-mission region. Mirrors
 * the cover-hero card's silhouette: eyebrow line + full-width cover block +
 * two text lines + a CTA-height block + the streak micro-line.
 *
 * The shared `<Skeleton>` uses `animate-pulse`, which Tailwind already pauses
 * under `prefers-reduced-motion` (the shimmer collapses to a static muted
 * block) — so reduced-motion is honored without extra wiring.
 */
export function FirstMissionSkeleton() {
  return (
    <div
      className="flex w-full flex-col gap-3"
      data-testid="first-mission-skeleton"
      aria-busy="true"
    >
      {/* Eyebrow */}
      <Skeleton className="h-3 w-32" />
      {/* Cover-hero card silhouette */}
      <div className="overflow-clip rounded-2xl border">
        <Skeleton className="h-[8.25rem] w-full rounded-none" />
        <div className="flex flex-col gap-2.5 px-4 pt-3.5 pb-4">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-1/2" />
          <Skeleton className="h-9 w-full rounded-md" />
        </div>
      </div>
      {/* Streak micro-line */}
      <Skeleton className="h-3 w-40 self-center" />
    </div>
  )
}

export default FirstMissionSkeleton
